module.exports = __webpack_public_path__ + "de77a722/img/note-list-icon.961c1485.svg";